// REACT
import { useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";

// CONTEXT
import { maincontext } from "../../context/maincontext";

// ASSETS
import languagePack from "../../assets/languages/languagePack";
import { FaEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import "../../assets/styles/productsList.css"; // Import CSS file

// SERVICES
import modalHandler from "../../services/modalHandler";

// COMPONENTS
import ConfirmModal from "../common/ConfirmModal";

// CUSTOM HOOKS
import { useDelete } from "../../hooks/useFetch";
import ProductForm from "./ProductForm";

export default function SingleProduct(props) {
    // CONTEXT VARS
    const { language, token, setAuthorized } = useContext(maincontext);

    // FETCH
    const [deleteRuleUrl, setDeleteRuleUrl] = useState(null);
    const deleteProduct = useDelete(deleteRuleUrl, token, setAuthorized);
    const [selectedID, setSelectedID] = useState(null);

    // MODAL
    const [confirmDeleteAnswer, setConfirmDeleteAnswer] = useState(false);

    useEffect(() => {
        if (confirmDeleteAnswer === true) {
            setDeleteRuleUrl(`${process.env.REACT_APP_BACKEND_BASE_URL}product/${selectedID}`);
            setConfirmDeleteAnswer(false);
        }

        // eslint-disable-next-line
    }, [confirmDeleteAnswer]);

    // Watch deleteProduct state and refetch when delete completes
    useEffect(() => {
        if (deleteProduct.error) {
            toast.error(languagePack[language].toast.errorProductDeletion, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            console.error("❌ Delete Error:", deleteProduct.error);
        }
        else if (deleteProduct.data && !deleteProduct.isPending && !deleteProduct.error) {
            toast.success(languagePack[language].toast.successfulProductDeletion, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            setSelectedID(null);
            props.setShowModal(false); // Close modal
            props.setRefetchTrigger(prev => !prev); // Trigger re-fetch
        }

        // eslint-disable-next-line
    }, [deleteProduct.data, deleteProduct.isPending, deleteProduct.error]);

    return (
        <tr className="table-row">
            <td>{props.product.product_name}</td>
            <td>{props.product.sku}</td>
            <td className="action-buttons">
                <button className="modifyBtn"
                    onClick={() => {
                        modalHandler(
                            <ProductForm
                                setShowModal={props.setShowModal}
                                isEdit={true}
                                setRefetchTrigger={props.setRefetchTrigger}
                                product={props.product}
                            />,
                            props.setModalItem,
                            true,
                            props.setShowModal
                        )
                    }}>
                    <FaEdit className="text-warning " />
                </button>
                <button
                    onClick={() => [
                        modalHandler(
                            <ConfirmModal
                                title={languagePack[language].productManager.confirmModalTitle}
                                productName={props.product.product_name}
                                setConfirmAnswer={setConfirmDeleteAnswer}
                                setShowModal={props.setShowModal}
                                isPending={deleteProduct.isPending}
                            />,
                            props.setModalItem,
                            true,
                            props.setShowModal
                        ),
                        setSelectedID(props.product.id),
                    ]}
                    className="deleteBtn"
                >
                    <MdDeleteForever className="text-danger" />
                </button>
            </td>
        </tr>
    );
}
